export const EnvConfig = Symbol.for('EnvConfig');
